/**
 * Where a scanned job label should land — `GET /api/workitems/by-number/{n}/scan-target`.
 *
 * The repair-ticket label's QR is `/j/{ticketNumber}`; the API picks the
 * destination from the job's live state (see `ScanTarget` in contracts and
 * docs/qr-scan-workflow-requirements.md §9).
 */

import type { ScanTarget } from '@techgitter/contracts';

const API_BASE_URL = '/api';

/** `null` when no job carries `ticketNumber`. */
export async function fetchScanTarget(
  ticketNumber: string,
  signal?: AbortSignal,
): Promise<ScanTarget | null> {
  const response = await fetch(
    `${API_BASE_URL}/workitems/by-number/${encodeURIComponent(ticketNumber)}/scan-target`,
    { headers: { Accept: 'application/json' }, signal },
  );
  if (response.status === 404) return null;
  if (!response.ok) {
    throw new Error(
      `Failed to resolve job ${ticketNumber}: ${response.status} ${response.statusText}`,
    );
  }
  return response.json();
}
